export default __webpack_public_path__ + "static/media/styled_components.a46dc006.png";